package com.futurions.portfolio.sections

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.silk.components.icons.fa.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.css.functions.blur
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexBasis
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.justifyContent
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.silk.components.forms.CheckboxKind
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.*
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.I

@Composable
fun ProfileHeader() {
    Box(
        modifier = Modifier
            .fillMaxSize() // takes full viewport height
            .display(DisplayStyle.Flex)
            .justifyContent(JustifyContent.Center) // centers horizontally
            .alignItems(AlignItems.Center) // centers vertically
    ) {
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .maxWidth(1100.px)
                .padding(48.px)
                .margin(top=40.px)
                .backgroundColor(rgba(255, 255, 255, 0.08))
                .backdropFilter(blur(16.px))
                .borderRadius(24.px)
                .boxShadow(
                    offsetX = 0.px,
                    offsetY = 1.px,
                    blurRadius = 20.px,
                    spreadRadius = 10.px,
                    color = rgba(0, 0, 0, 0.25)
                )
        ) {
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .gap(48.px)
                    .flexWrap(FlexWrap.Wrap)
                    .justifyContent(JustifyContent.Center),
                verticalAlignment = Alignment.CenterVertically
            ) {
                // ✅ RIGHT SIDE — Profile Picture
                Image(
                    src = "/images/profile2.jpg",
                    description = "Profile Picture",
                    modifier = Modifier
                        .size(250.px)
                        .borderRadius(50.percent)
                        .boxShadow(blurRadius = 12.px, color = rgba(0, 0, 0, 0.2))
                        .objectFit(ObjectFit.Cover)
                )
                // LEFT SIDE — About Section
                Column(
                    modifier = Modifier
                        .flexBasis(50.percent)
                        .maxWidth(500.px)
                ) {
                    SpanText(
                        text = "👋 Hi, I'm",
                        modifier = Modifier
                            .fontSize(18.px)
                            .color(rgb(200, 200, 200))
                            .padding(bottom = 4.px)
                    )
                    SpanText(
                        text = "Gaurav Singh",
                        modifier = Modifier
                            .fontSize(36.px)
                            .fontWeight(FontWeight.Bold)
                            .color(rgb(255, 255, 255))
                            .padding(bottom = 8.px)
                    )
                    SpanText(
                        text = "Android & KMP Developer",
                        modifier = Modifier
                            .fontSize(20.px)
                            .color(rgb(210, 210, 210))
                            .padding(bottom = 8.px)
                    )
                    SpanText(
                        text = "I build cross-platform mobile apps with Kotlin Multiplatform and Jetpack Compose, focusing on clean UI and smooth user experiences. I’m also passionate about game development and enjoy creating gameplay systems in Unreal Engine and Godot.",
                        modifier = Modifier
                            .lineHeight(28.px)
                            .fontSize(16.px)
                            .color(rgb(220, 220, 220))
                            .padding(bottom = 8.px)
                    )

                    // ✅ Social Icons Row
                    Row(
                        modifier = Modifier
                            .gap(26.px)
                            .padding(top = 12.px),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        SocialIcon("https://github.com/gauravsingh2906") { FaGithub() }
                        SocialIcon("https://www.linkedin.com/in/gaurav-singh-913b6728a") { FaLinkedin() }
                        SocialIcon("https://play.google.com/store/apps/details?id=com.futurion.apps.mindmingle") { FaGooglePlay() }

                    }
                }



            }
        }
    }
}


@Composable
fun SocialIcon(url: String, icon: @Composable () -> Unit) {
    A(
        href = url,
        attrs = {
            attr("target", "_blank")
            attr("rel", "noopener noreferrer")
        }
    ) {
        Box(
            modifier = Modifier
                .fontSize(28.px)
                .color(rgb(255, 255, 255))
                .transition(Transition.of("transform", 0.3.s))
                .cursor(Cursor.Pointer)

        ) {
            icon()
        }
    }
}

@Composable
fun IconLink(icon: Unit, url: String, color: CSSColorValue) {
    Link(
        path = url,
        modifier = Modifier
            .fontSize(28.px)
            .color(color)
            .transition(Transition.of("all", 0.3.s))
    ) {
        FaIcon(name = icon.toString(), modifier = Modifier.cursor(Cursor.Pointer))
    }
}
